import { Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import Dashboard from "./Pages/Dashboard";
import { AlertProvider } from "./contexts/alertContext";
import React from "react";
import Login from "./Pages/Auth/Login/Login";

const App: React.FC = () => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
        <AlertProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<Dashboard />} />
          </Routes>
        </AlertProvider>
    </QueryClientProvider>
  );
};

export default App;
